import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=66d287c5&scoped=true"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=66d287c5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d287c5",
  null
  
)

export default component.exports